module.exports = __webpack_public_path__ + "static/img/08-1banner.b4bde613.png";